import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {TemplateControllerService} from '../../services';
import {Configuration} from '../../models';
import {ConfirmationDialogComponent} from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-template-dialog',
  templateUrl: './template-dialog.component.html',
  styleUrls: ['./template-dialog.component.css']
})

export class TemplateDialogComponent implements OnInit {
  templates: Configuration[];
  searchText: any;

  constructor(
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private templateService: TemplateControllerService,
    public confirmationDialog: MatDialog) {}

  selectTemplate(template): void {
    this.dialogRef.close(template);
  }

  ngOnInit(): void {
    this.templateService.listTemplatesUsingGET().subscribe(res => {
      this.templates = res.sort( (a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) {
          return -1;
        }
      });
    });
  }

  deleteButton(template) {
    this.openConfirmationDialog(template);
  }
  deleteTemplate(template) {
    if (template.id == null) {
      this.templateService.deleteTemplateUsingDELETE('0').subscribe(res => {
        this.removeTemplateFromList(template);
      });
    } else {
      this.templateService.deleteTemplateUsingDELETE(template.id).subscribe(res => {
        this.removeTemplateFromList(template);
      });
    }
  }

  removeTemplateFromList(request) {
    const index = this.templates.indexOf(request);
    this.templates.splice(index, 1);
  }

  exportTemplate(template: Configuration) {
    window.opener.location = '../uploadRequest/template/export/' + template.id;
  }

  openConfirmationDialog(template) {
    const confirmationDialogRef = this.confirmationDialog.open(ConfirmationDialogComponent, {width: '500px'});
    confirmationDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteTemplate(template);
      }
    });
  }
}

export interface DialogData {
  groupDeleteTemplate;
}
